.track {
  width: 100%;
  height: 6px;
  border-radius: 4px;
  background: var(--surf3);
  overflow: hidden;
}
.fill {
  height: 100%;
  border-radius: 3px;
  transition: width 0.3s ease;
}
